export default [
  '',
  'Jr',
  'Sr',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'Other',
];

// PVQ Dropdown values
export const nameSuffixes = [
  '',
  'Jr',
  'Sr',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'Other',
  'None',
  'I Don\'t Know',
];
